import gql from 'graphql-tag';

import postFragment from '~/shared/graphql-queries/posts/post-fragment';

export default gql`
  query findManyPostQuery(
    $limit: Int = 20
    $filter: FilterFindManyPostInput
    $sort: SortFindManyPostInput
  ) {
    findManyPostQuery(filter: $filter, skip: 0, limit: $limit, sort: $sort) {
      ...PostFragment
    }
  }
  ${postFragment}
`;
